<template lang="pug">
<div>
expired-distribution-dialog(ref="expiredDistributionDialog")
breadcrumbs(section='Find Videos')
// Page loader
md-progress.md-accent(md-indeterminate, v-if='loadingComponent')
// Content
.page-container(v-else)
  div.expiredInfo(v-if="showExpiredDate")
    button(@click='deadLineInfo') There are distributions or licenses that have expired or are about to expire
    button(@click="closeShowExpiredDate") X
  // Filters
  md-layout(md-flex='100', md-theme='blue')
    md-whiteframe.filters-frame
      media-item-filters(:search='search', @getNetworksError='showAlertToast($event, "error")', @goSearch='updateQueryAndSearch', @cleanSearch="cleanInputs" )
  md-layout.content-frame(:md-gutter='16')
    md-layout(md-flex='25')
      // Playlists
      md-whiteframe.playlist-frame(md-elevation='3')
        playlists(@error='showAlertToast($event, "error")')
    md-layout.margin-top(md-flex='75')
      md-layout(md-column='')
        md-layout(md-flex='100')
          stitch-loader(:loading='searching', :size='45')
            md-layout#cards-index-container(:md-gutter='16', md-align='center')
              // Results
              md-layout#item-card-index-container.media-row(
                md-flex-xsmall='100',
                md-flex-small='50',
                md-flex-medium='30',
                md-flex-large='30',
                md-flex-xlarge='30',
                v-for='item of searchResults',
                :key='item._id'
              )
                stitch-media-item(
                  :item='item',
                  @addToPlaylistError='showAlertToast($event, "error")', 
                  @removeFromPlaylistError='showAlertToast($event, "error")'
                ).marketplaceTitle
            // Infinte scroll loader
            md-layout.spinnerBlock(md-align='center', id='loaderLayout')
              infinite-loading(@infinite='loadMoreResults' :identifier="resetIdentifier" v-show='totalItemsForSearch > 20')
                md-spinner.md-accent(md-indeterminate, :md-size='60', slot='spinner')
                span(slot='no-more')

            div#no-results(v-if="totalItemsForSearch === 0")
              div.second
                md-icon.md-accent(md-iconset="fa fa-exclamation-circle",)
                | No items to show
</div>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import mediaItemService from "../../services/mediaItemService";
import StitchLoader from "../../shared-components/Loader";
import StitchMediaItem from "../../shared-components/mediaItem/MediaItem";
import Playlists from "../../shared-components/playlist/Playlists";
import MediaItemFilters from "../../shared-components/mediaItem/MediaItemFilters";
import Languages from "../../assets/data/languages";
import Breadcrumbs from "../../shared-components/Breadcrumbs";
import distributionService from '../../services/distributionService';
import licenseService from '../../services/licenseService';
import ExpiredDistributionDialog from '../marketplace/expiredDistributionDialog.vue'
import Cookies from 'js-cookie';


// Build request params for search
function digestData(searchData) {
  const data = {};
  const { name, network, language, sort, genre, limit, offset } = searchData;
  if (name) {
    Object.assign(data, { name });
  }
  if (network) {
    Object.assign(data, { network });
  }
  if (language) {
    Object.assign(data, { language });
  }
  if (genre) {
    Object.assign(data, { genre });
  }
  Object.assign(data, sort, {
    limit,
    offset,
    marketplace: true,
    encodingStatus: "completed",
    status: "public",
  });
  return data;
}

export default {
  components: {
    InfiniteLoading,
    StitchLoader,
    StitchMediaItem,
    Playlists,
    MediaItemFilters,
    Breadcrumbs,
    ExpiredDistributionDialog
  },
  data() {
    return {
      loadingComponent: false,
      searching: false,
      search: {
        name: this.$route.query.name || "",
        network: this.$route.query.network || "",
        language: this.getLanguage(),
        sort: {
          sortBy: this.$route.query.sortBy || "lastUpdated",
          sortOrder: this.$route.query.sortOrder || "desc",
        },
        genre: this.$route.query.genre || "",
        offset: 0,
        limit: 20,
      },
      searchResults: [],
      totalItemsForSearch: null,
      distribution: [],
      distributionExpired: [],
      deadLineDistribution: [],
      licenses: [],
      licensesExpired: [],
      deadLineLicenses: [],
      currentDate: new Date().toISOString(),
      showExpiredDate: false,
      resetIdentifier: 0,

    };
  },
  computed: {
    scrollDisabled() {
      return this.searchResults.length >= this.totalItemsForSearch;
    },
  },
  methods: {
    showAlertToast(text, icon) {
      console.log(`showAlertToast ~ text: ${text}, icon: ${icon}`)
    },

    getLanguage() {
      const language = Languages.find(
        (lang) => lang.code === this.$route.query.language
      );
      return language ? language.name : "";
    },
    cleanInputs() {
      this.search.name = ''
      this.search.genre = ''
      this.search.network = ''
      this.search.language = ''
      this.searchMarketplace()

    },
    updateQueryAndSearch() {
      // Update the query string
      const { name, network, language, sort, genre } = this.search;
      const query = {};
      if (name) {
        Object.assign(query, { name });
      }
      if (network) {
        Object.assign(query, { network });
      }
      if (language) {
        Object.assign(query, { language });
      }
      if (sort) {
        Object.assign(query, { sortBy: sort.sortBy });
        Object.assign(query, { sortOrder: sort.sortOrder });
      }
      if (genre) {
        Object.assign(query, { genre });
      }
      this.$router.replace({
        name: "Marketplace",
        query,
      });
      // Search
      this.searchMarketplace();
    },
    async searchMarketplace() {
      this.searching = true;
      this.searchResults = [];
      this.totalItemsForSearch = 0;
      this.search.offset = 0;
      const params = digestData(this.search);
      document.getElementById("loaderLayout").style.display = "block";

      try {
        const response = await mediaItemService.getList(params);
        this.searchResults = response.data.mediaItems;
        this.totalItemsForSearch = response.data.total;
        this.deleteBlankDivs();
      }
      catch (err) {
        console.error("searchMarketplace ~ err:", err);
        await this.$swal.fire({
          text: "Session expired. Please login again",
          icon: 'warning',
          timer: 4000,
          timerProgressBar: true,
          showConfirmButton: true
        });
        Cookies.remove('dateTimeCloseExpiredAlert');
        this.$router.push('/logout');
      }
      finally {
        this.searching = false;
        this.deleteBlankDivs();
        document.getElementById("loaderLayout").style.display = "none";
      }
  },
  async loadMoreResults($state) {
    this.search.offset += this.search.limit;
    const params = digestData(this.search);

    try {
      const response = await mediaItemService.getList(params);
      if (this.scrollDisabled) {
        $state.complete();
        document.getElementById("loaderLayout").style.display = "none";
      } else {
        this.searchResults.push(...response.data.mediaItems);
        $state.loaded();
      }
      this.deleteBlankDivs();
    } catch (error) {
      console.error('Error while retrieving more results:', error);
      this.showAlertToast('Error while retrieving more results. Please try again later', 'error');
      $state.complete();
    }
  },
    deleteBlankDivs() {
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          let nodes = document.getElementsByClassName(
            "md-layout media-row md-flex-xsmall-100 md-flex-small-50 md-flex-medium-30 md-flex-large-30 md-flex-xlarge-30"
          );
          for (let index in nodes) {
            if (nodes[index].textContent == "") {
              nodes[index].remove();
            }
          }
        }
      }, 1500);
    },

    closeShowExpiredDate() {
      Cookies.set('dateTimeCloseExpiredAlert', this.currentDate);
      this.showExpiredDate = false
      this.showAlertToast('This notification will disappear until your next login', 'info')
    },

    deadLineInfo() {
      this.$refs.expiredDistributionDialog.openDialog({ expiredDistribution: this.distributionExpired, deadLineDistribution: this.deadLineDistribution, expiredLisenses: this.licensesExpired, deadLineLisenses: this.deadLineLicenses })
    },

    getExpiredDates() {
      const dateTime = Cookies.get("dateTimeCloseExpiredAlert");
      const twoDayAgo = new Date(Date.now() - 172800000).toISOString();
      const date = new Date(this.currentDate)
      const deadLine = new Date(date.getTime() + 7 * 24 * 60 * 60 * 1000).toISOString();

      if( dateTime === undefined || twoDayAgo > dateTime ) {
        this.getLicenses(deadLine)
        this.getDistribution(deadLine)
      }
    },

    getDistribution(deadLine) {
      distributionService.getList({ offset: 0, limit: 100, sortBy: 'lastUpdated', sortOrder: 'desc' })
        .then((response) => {
          this.distribution = response.data.distributions
          this.distribution.map(
            (item) => {
              if (this.currentDate >= item.endDate && item.status !== 'draft') {
                this.showExpiredDate = true
                this.distributionExpired.push(item);
              }
              if (item.endDate <= deadLine && this.currentDate <= item.endDate && item.status !== 'draft') {
                this.showExpiredDate = true
                this.deadLineDistribution.push(item);
              }
            },
          )
        })
        .catch((error) => {
          console.error('Error while retrieving the list of distributions', error);
        })
    },

    getLicenses(deadLine) {
      licenseService.getList({ offset: 0, limit: 100, sortBy: 'lastUpdated', sortOrder: 'desc' })
        .then((response) => {
          this.licenses = response.data.licenses;
          this.licenses.map(
            (item) => {
              if (this.currentDate >= item.endDate && item.status !== 'draft') {
                this.showExpiredDate = true
                this.licensesExpired.push(item);
              }
              if (item.endDate <= deadLine && this.currentDate <= item.endDate && item.status !== 'draft') {
                this.showExpiredDate = true
                this.deadLineLicenses.push(item);
              }
            }
          )
        })
        .catch((error) => {
          console.error('Error while retrieving the list of licenses', error);
        })
    }
  },
  mounted() {
    this.getExpiredDates()
    this.search.name = '';
    this.$session.set("iWasInPage", 1);
    this.$session.set("iWasInPageNetworks", 1);
    this.$session.set("iWasInPagePlaylist", 1);
    this.$session.set("iWasInPageSeries", 1);
    this.$session.set("iWasInPageUserActivity", 1);
    this.$session.set("iWasInPageDistributions", 1);
    this.$session.set("iWasInPageDomains", 1);
    this.$session.set("iWasInPageLicences", 1);
    this.$session.set("iWasInPageVideoSources", 1);
    this.loadingComponent = true;
    this.searchMarketplace()
      .then(() => {
        this.loadingComponent = false;
      })
      .catch(() => {
        this.loadingComponent = false;
      });
  },
};
</script>

<style lang="scss" scoped>
.alert {
  .md-icon {
    margin-right: 5px;
    color: #ffbf00;
  }
}

.page-container {
  padding: 10px 10px 0 10px;

  .filters-frame {
    margin-bottom: 15px;
    width: 100%;
    padding: 5px 25px;
  }

  .spinnerBlock {
    display: block !important;
  }

  .content-frame {
    $total-height: calc(100vh - 231px);
    height: $total-height;
    overflow-y: scroll;

    .playlist-frame {
      height: $total-height;
      position: absolute;
      overflow-y: scroll;
      width: calc(25% - 16px);
    }
  }
}

.media-row {
  margin-bottom: 16px;
}

#no-results {
  display: flex;
  justify-content: center;
  padding: 20px;
}
.md-icon {
  margin-right: 5px;
} 

.margin-top {
  margin-top: 5px;
}

.containerExpired {
  display: flex;
  justify-content: space-around;
}

.expiredInfo {
  background-color: #ee922af3;
  display: flex;
  justify-content: space-between;
  padding: 3px;

  :first-child {
    color: #fffdfa;
    font-weight: 600;
    margin: auto;

  }

  button {
    background-color: transparent;
    border: none;
    color: #fff;
    font-weight: 700;
    margin-right: 10px;
    padding: 5px;

    &:hover {
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/marketplace/index.vue